import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/common/Button';
import Icon from '../../components/common/Icon';
import { adminAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { formatDate, formatDateTime } from '../../utils/dateTime';
import PaginationBar from '../../components/common/PaginationBar';

const AdminPenalties = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [pagination, setPagination] = useState({ page: 0, size: 20, totalPages: 1, totalElements: 0 });

  const fetchPenalties = async (page = 0) => {
    setLoading(true);
    try {
      const response = await adminAPI.getPenaltyOrders(page, pagination.size);
      const payload = response.data?.data || response.data || {};
      const rows = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : []);
      setOrders(rows);
      setPagination((prev) => ({
        ...prev,
        page: payload.pageNumber ?? page,
        totalPages: payload.totalPages || 1,
        totalElements: payload.totalElements || rows.length,
      }));
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || 'Failed to load penalty orders');
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPenalties(0);
  }, []);

  const orderFormFilledDate = (order) =>
    formatDateTime(order.orderFormFilledAt || order.creationDate, '—');

  return (
    <div style={{ padding: '24px', flex: 1, background: '#f8fafc', overflow: 'auto' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', gap: '12px', flexWrap: 'wrap' }}>
          <div>
            <h1 style={{ margin: '0 0 6px 0', fontSize: '28px', fontWeight: 800, color: '#1e293b' }}>Penalty Orders</h1>
            <p style={{ margin: 0, color: '#64748b' }}>Orders marked with a late-refund penalty amount</p>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button variant="secondary" onClick={() => navigate('/admin')}>Dashboard</Button>
            <Button onClick={() => fetchPenalties(pagination.page)} loading={loading} icon="refresh">Refresh</Button>
          </div>
        </div>

        <div style={{ background: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1000px' }}>
              <thead>
                <tr style={{ background: '#f8fafc' }}>
                  {['Order ID', 'Reviewer', 'Mediator', 'Status', 'Penalty ₹', 'Order Form Filled', 'Refund Filled', 'Product'].map((h) => (
                    <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#64748b', textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={8} style={{ padding: '32px', textAlign: 'center', color: '#64748b' }}>Loading...</td></tr>
                ) : orders.length === 0 ? (
                  <tr><td colSpan={8} style={{ padding: '32px', textAlign: 'center', color: '#64748b' }}>No penalty orders found</td></tr>
                ) : orders.map((order) => (
                  <tr key={order.id} style={{ borderTop: '1px solid #e2e8f0' }}>
                    <td style={{ padding: '12px 16px', fontWeight: 600 }}>{order.orderId}</td>
                    <td style={{ padding: '12px 16px' }}>{order.reviewerName || order.userEmail || '—'}</td>
                    <td style={{ padding: '12px 16px' }}>{order.mediatorName || '—'}</td>
                    <td style={{ padding: '12px 16px' }}>{order.orderStatus}</td>
                    <td style={{ padding: '12px 16px', color: '#dc2626', fontWeight: 700 }}>₹{Number(order.penaltyAmount || 0).toLocaleString()}</td>
                    <td style={{ padding: '12px 16px' }}>{orderFormFilledDate(order)}</td>
                    <td style={{ padding: '12px 16px' }}>{order.refundFormFilledDate ? formatDate(order.refundFormFilledDate) : 'MISSED'}</td>
                    <td style={{ padding: '12px 16px' }}>{order.productName || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ padding: '8px 16px', borderTop: '1px solid #e2e8f0' }}>
            <PaginationBar
              page={pagination.page}
              totalPages={pagination.totalPages}
              totalElements={pagination.totalElements}
              pageSize={pagination.size}
              onPageChange={(page) => fetchPenalties(page)}
            />
          </div>
        </div>

        <div style={{ marginTop: '16px', padding: '14px 16px', background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: '12px', color: '#9a3412', display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
          <Icon name="alert-triangle" size={18} color="#ea580c" />
          <div style={{ fontSize: '14px' }}>
            Penalty is applied when a buyer fills the refund form after the configured late days from the order form filled date. If refund form date is missing, it shows as MISSED.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPenalties;
